import Vue from "vue";
import Axios from "axios";
import Swal from "sweetalert2";
import router from "../router";
const moduleCreateEditWord = {
  state: {
    header_token: {
      headers: { token: Vue.prototype.$session.get("token_roy") },
    },
    language_list: [],
    category_list: [],
    //create
    selected_language: [],
    created_word: {
      categoryId: 0,
      mean: "",
      subLanguage: [],
    },
    selected_id: [],
    pointerId: 0,
    createMode: null,
    btn_loading: false,
    requestwordId: null,
    selected_language_edit_mode: [],
    btn_public: false,
  },
  mutations: {
    async getMasterData(state) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      // language
      var language = await Axios.get(
        process.env.VUE_APP_API + "api/v1/masterdata/language",
        header_token
      );

      state.language_list = await language.data;

      // category
      var category = await Axios.get(
        process.env.VUE_APP_API + "api/v1/masterdata/category",
        header_token
      );
      state.category_list = await category.data;
    },
    createWord(state) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      state.btn_loading = true;
      state.created_word.mean = state.created_word.mean.trim();
      state.created_word.subLanguage.forEach((element) => {
        element.alphabet = element.alphabet.trim();
        element.transcriptionList.forEach((item) => {
          item.transcriptionName = item.transcriptionName.trim();
        });
      });
      var data = state.created_word;
      Axios.post(
        process.env.VUE_APP_API + "api/v1/admin/romanlanguage",
        data,
        header_token
      )
        .then((res) => {
          // console.log(res.data);
          if (res.data == "create success") {
            if (state.createMode == "request") {
              this.commit("changeRequestWordStatus");
              Swal.fire({
                icon: "success",
                title: "บันทึกข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.commit("clearData");
            } else {
              Swal.fire({
                icon: "success",
                title: "บันทึกข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.commit("clearData");
            }

            router.push({ name: "Dashboard", params: { mode: "all" } });
          } else if (res.data.message == "already exists") {
            state.btn_loading = false;
            if (state.createMode == "request") {
              state.pointerId = res.data.pointerId;
              this.commit("createSubLanguage");
            } else {
              Swal.fire({
                icon: "warning",
                title: "มีข้อมูลนี้แล้ว",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "ผิดพลาด",
              text: "กรุณาลองใหม่อีกครั้ง",
            });
            this.commit("clearData");
            router.push({ name: "Dashboard", params: { mode: "all" } });
          }
        })
        .catch((err) => {
          state.btn_loading = false;
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด",
            text: "กรุณาลองใหม่อีกครั้ง",
          });
        });
    },
    createSubLanguage(state) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      state.btn_loading = true;
      var data = {
        alphabet: state.created_word.subLanguage[0].alphabet.trim(),
        languageId: state.created_word.subLanguage[0].languageId,
        pointerId: state.pointerId,
        rule: "",
        subLanguageId: 0,
        transcriptionList: state.created_word.subLanguage[0].transcriptionList,
      };
      data.transcriptionList.forEach((element) => {
        element.transcriptionName = element.transcriptionName.trim();
      });
      Axios.post(
        process.env.VUE_APP_API + "api/v1/admin/sublanguage",
        data,
        header_token
      )
        .then((res) => {
          // console.log(res.data);
          if (res.data == "create success") {
            state.btn_loading = false;
            Swal.fire({
              icon: "success",
              title: "บันทึกข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.commit("clearData");
            this.commit("changeRequestWordStatus");
            router.push({ name: "Dashboard", params: { mode: "all" } });
          } else if (res.data == "already exists") {
            state.btn_loading = false;
            Swal.fire({
              icon: "warning",
              title: "มีภาษานี้แล้ว",
              text: "ไม่สามารถบันทึกข้อมูลได้",
              // showConfirmButton: false,
              // timer: 1000,
            });
            this.commit("clearData");
            router.push("/requestword");
          } else {
            Swal.fire({
              icon: "error",
              title: "ผิดพลาด",
              // showConfirmButton: false,
              // timer: 1000,
            });
            this.commit("clearData");
            router.push("/requestword");
          }
        })
        .catch((err) => {
          state.btn_loading = false;
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด",
            text: "กรุณาลองใหม่อีกครั้ง",
            // showConfirmButton: false,
            // timer: 1000,
          });
        });
    },
    changeRequestWordStatus(state) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      var id = state.requestWordId;
      var data = {
        requestWordStatus: "active",
      };
      Axios.put(
        process.env.VUE_APP_API + "api/v1/requestword/status/" + id,
        data,
        header_token
      ).then((res) => {
        // console.log(res.data);
      });
    },
    getWordByPointerIdViewMode(state, data) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      // console.log(data);
      var pointerId = data;
      state.pointerId = pointerId;
      state.selected_language = [];

      Axios.get(
        process.env.VUE_APP_API + "api/v1/admin/romanlanguage/" + pointerId,
        header_token
      ).then((res) => {
        // console.log(res.data);
        if (res.data) {
          var data = res.data;
          state.created_word = {
            categoryId: data.categoryId,
            mean: data.mean,
            subLanguage: data.subLanguage,
          };
          data.subLanguage.forEach((element) => {
            var include = state.selected_language.includes(element.languageId);
            // console.log(include);
            if (include == false) {
              state.selected_language.push(element.languageId);
            }
          });
          // console.log(state.selected_language);
          router.push({
            name: "Create Word",
            params: { mode: "detail" },
            query: { id: pointerId },
          });
        }
      });
    },
    getWordByPointerId(state, data) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      // console.log(data);
      state.selected_language = [];
      var pointerId = data;
      state.pointerId = pointerId;
      this.commit("clearData");

      Axios.get(
        process.env.VUE_APP_API + "api/v1/admin/romanlanguage/" + pointerId,
        header_token
      ).then((res) => {
        // console.log(res.data);
        if (res.data) {
          var data = res.data;
          state.created_word = {
            categoryId: data.categoryId,
            mean: data.mean,
            subLanguage: data.subLanguage,
          };
          data.subLanguage.forEach((element) => {
            var include = state.selected_language.includes(element.languageId);
            // console.log(include);
            if (include == false) {
              state.selected_language.push(element.languageId);
            }
          });

          router.push({
            name: "Create Word",
            params: { mode: "edit" },
            query: { id: pointerId },
          });
        }
      });
    },
    editWord(state, data) {
      let header_token = {
        headers: { token: Vue.prototype.$session.get("token_roy") },
      };
      state.btn_loading = true;
      state.created_word.mean = state.created_word.mean.trim();
      var pointerId = data;
      var subLanguage = [];
      state.created_word.subLanguage.forEach((element) => {
        subLanguage.push({
          languageId: element.languageId,
          subLanguageId: element.subLanguageId ? element.subLanguageId : 0,
          alphabet: element.alphabet.trim(),
          rule: element.rule ? element.rule : "",
          transcriptionList: element.transcriptionList,
        });
      });
      subLanguage.forEach((element) => {
        element.transcriptionList.forEach((item) => {
          item.transcriptionName = item.transcriptionName.trim();
        });
      });
      var data = {
        categoryId: state.created_word.categoryId,
        mean: state.created_word.mean,
        subLanguage: subLanguage,
      };
      // console.log(data);
      Axios.put(
        process.env.VUE_APP_API + "api/v1/admin/romanlanguage/" + pointerId,
        data,
        header_token
      )
        .then((res) => {
          // console.log(res.data);
          if (res.data == "update success") {
            state.btn_loading = false;
            Swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.commit("clearData");
            router.push({ name: "Dashboard", params: { mode: "all" } });
          } else if (res.data == "already exists") {
            Swal.fire({
              icon: "warning",
              title: "มีข้อมูลนี้แล้ว",
              // showConfirmButton: false,
              // timer: 1000,
            });
          } else {
            state.btn_loading = false;
            Swal.fire({
              icon: "error",
              title: "ผิดพลาด",
              text: "กรุณาลองใหม่อีกครั้ง",
              // showConfirmButton: false,
              // timer: 1000,
            });
            this.commit("clearData");
            router.push({ name: "Dashboard", params: { mode: "all" } });
          }
        })
        .catch((err) => {
          state.btn_loading = false;
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด",
            text: "กรุณาลองใหม่อีกครั้ง",
            // showConfirmButton: false,
            // timer: 1000,
          });
        });
    },
    clearData(state) {
      state.selected_language = [];
      state.selected_id = [];
      state.selected_language_edit_mode = [];
      state.createMode = null;
      state.btn_loading = false;
      state.btn_public = false;
      state.created_word = {
        categoryId: 0,
        mean: "",
        subLanguage: [],
      };
    },
  },
};
export default moduleCreateEditWord;
